import km from 'keymirror'
import _ from 'underscore'

export default _.extend({
  // 积分流水记录类型
  BALANCE_RECORD_TYPE_CONSUMPTION: 1, // 消费
  BALANCE_RECORD_TYPE_ROLLBACK: 2, // 回滚
  BALANCE_RECORD_TYPE_REFUND: 3, // 退费
  BALANCE_RECORD_TYPE_RECHARGE: 4, // 充值
  BALANCE_RECORD_TYPE_WITHDRAW: 5, // 提现

  // 积分使用规则说明
  BALANCE_RULE_DECRIPTION_URL: 'https://m.sdyxmall.com/act/active/fKieYR730084', //Rule description
}, km({
  BALANCE_GETBALANCERECORD_SUCCESS: null,
  BALANCE_GETBALANCERECORD_ERROR: null,
  BALANCE_GETUSERBALANCE_SUCCESS: null,
  BALANCE_GETUSERBALANCE_ERROR: null,
  BALANCE_GETBALANCERECORDDETAIL_SUCCESS: null,
    BALANCE_GETBALANCERECORDDETAIL_ERROR: null,
    /*yeoman-template-point-1*/

}))
